import { useForm } from "react-hook-form";
import { useState } from "react";
import Form from "../../../ui/Form";
import FileField from "../../../ui/FileField";
import ModalScreenTitle from "../../../layout/admin/ModalScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import modalStyles from "../../../layout/admin/Modal.module.scss";
import { validateRequired } from "../../../../utils/validate";
import { postUploadCourseApplicant } from "../../../../services/apiCourseApplicant";
import { MAX_UPLOAD_SIZE } from "../../../../utils/config";

const CourseApplicantUploadModal = (props) => {
  // アップロード完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // ローディング画像表示
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  // アップロード
  async function onSubmit(data) {
    setLoading(true);
    // アップロード処理
    const json = await postUploadCourseApplicant(data);
    if (json) {
      if (json.result) {
        // アップロード完了画面表示
        setCompFlg(true);
      } else {
        setLoading(false);
        setError("course_applicant", { message: json.msg });
      }
    }
  }

  const closeModal = () => {
    // モーダル閉じる
    props.setShowModal(false);
  };

  const returnContents = (flg) => {
    if (flg) {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.lotterymodalContent}>
            <div className={modalStyles.lotteryModalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>講座申込情報アップロード完了</ModalScreenTitle>
            <Explanation>講座申込情報アップロードが完了しました。</Explanation>
            <div className={styles.buttonbox}>
              <a onClick={() => closeModal()}>
                <span className={styles.decoration}>閉じる</span>
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.uploadModalContent}>
            <div className={modalStyles.uploadModalButtonWrap}>
              <button
                disabled={loading}
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>講座申込情報アップロード</ModalScreenTitle>
            <Explanation>
              ファイルを選択し、アップロードボタンを押してください。 <br />
              ※未登録の学生の申込情報は登録されません。
            </Explanation>
            <div className="mt-5">
              <Form onSubmitHandler={handleSubmit(onSubmit)}>
                <FileField
                  name="course_applicant"
                  label="申込情報CSVファイル"
                  accept="text/csv"
                  register={register}
                  validation={{
                    ...validateRequired(),
                  }}
                  errors={errors}
                  setValue={setValue}
                  setError={setError}
                  clearErrors={clearErrors}
                  required={true}
                  maxSize={MAX_UPLOAD_SIZE}
                />
                <div className={styles.buttonbox}>
                  {loading ? (
                    <p>
                      <Explanation>
                        <img
                          id="ImageProgress"
                          className={styles.loadingGif}
                          src="/common/assets/images/processing.gif"
                        />
                        <span className="ps-3">登録中です・・・</span>
                      </Explanation>
                    </p>
                  ) : (
                    <Button type="submit" styleType="new">
                      アップロード
                    </Button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </div>
      );
    }
  };

  return <>{props.showFlag ? returnContents(compFlg) : <></>}</>;
};

export default CourseApplicantUploadModal;
